import { DataResponse, DimensionOrMeasure, NativeDataType } from '@embeddable.com/core';
import { FilterBuilderFilter } from '../definition';
import { SingleSelectField } from '@embeddable.com/remarkable-ui';
import { Theme } from '../../../../theme/theme.types';
import FilterBuilderItemValueField from './FilterBuilderItemValueField';
import { useEffect } from 'react';
import styles from '../FilterBuilderPro.module.css';
import { i18n } from '../../../../theme/i18n/i18n';
import { operatorNumber, operatorStringBoolean } from '../FilterBuilderPro.utils';

const getOperatorsString = () => [
  { value: operatorStringBoolean.is, label: i18n.t('editors.filterBuilder.is') },
  { value: operatorStringBoolean.isNot, label: i18n.t('editors.filterBuilder.isNot') },
  { value: operatorStringBoolean.isOneOf, label: i18n.t('editors.filterBuilder.isOneOf') },
  { value: operatorStringBoolean.isNotOneOf, label: i18n.t('editors.filterBuilder.isNotOneOf') },
  { value: operatorStringBoolean.contains, label: i18n.t('editors.filterBuilder.contains') },
];

const getOperatorsBoolean = () => [
  { value: operatorStringBoolean.is, label: i18n.t('editors.filterBuilder.is') },
  { value: operatorStringBoolean.isNot, label: i18n.t('editors.filterBuilder.isNot') },
  { value: operatorStringBoolean.isOneOf, label: i18n.t('editors.filterBuilder.isOneOf') },
  { value: operatorStringBoolean.isNotOneOf, label: i18n.t('editors.filterBuilder.isNotOneOf') },
];

const getOperatorsNumber = () => [
  { value: operatorNumber.equals, label: i18n.t('editors.filterBuilder.equals') },
  { value: operatorNumber.notEquals, label: i18n.t('editors.filterBuilder.doesNotEqual') },
  { value: operatorNumber.gte, label: i18n.t('editors.filterBuilder.greaterThanOrEqualTo') },
  { value: operatorNumber.lte, label: i18n.t('editors.filterBuilder.lessThanOrEqualTo') },
  { value: operatorNumber.between, label: i18n.t('editors.filterBuilder.between') },
];

type FilterBuilderItemOperatorValueFieldsProps = {
  dimensionOrMeasure: DimensionOrMeasure;
  filter: FilterBuilderFilter;
  results?: DataResponse;
  theme: Theme;
  onSelectOperator: (value: string | null) => void;
  onSelectValue: (value: FilterBuilderFilter['value']) => void;
  onSearchValue: (value: string) => void;
};

const FilterBuilderItemOperatorValueFields = ({
  dimensionOrMeasure,
  filter,
  results,
  theme,
  onSelectOperator,
  onSelectValue,
  onSearchValue,
}: FilterBuilderItemOperatorValueFieldsProps) => {
  let operatorOptions;
  if (dimensionOrMeasure.nativeType === NativeDataType.number) {
    operatorOptions = getOperatorsNumber();
  } else if (dimensionOrMeasure.nativeType === NativeDataType.boolean) {
    operatorOptions = getOperatorsBoolean();
  } else {
    operatorOptions = getOperatorsString();
  }

  useEffect(() => {
    if (!filter.operator) {
      onSelectOperator(operatorOptions[0]!.value);
    }
  });

  return (
    <>
      <SingleSelectField
        triggerComponent={
          <button className={styles.operatorButton}>
            {operatorOptions.find((x) => x.value === filter.operator)?.label}
          </button>
        }
        value={filter.operator}
        options={operatorOptions}
        onChange={onSelectOperator}
        avoidCollisions={false}
      />
      <FilterBuilderItemValueField
        filter={filter}
        dimensionOrMeasure={dimensionOrMeasure}
        results={results}
        theme={theme}
        onSelectValue={onSelectValue}
        onSearchValue={onSearchValue}
      />
    </>
  );
};

export default FilterBuilderItemOperatorValueFields;
